import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../styles/controls.css";

import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

export default L;